import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import Loading from "../../components/loading";
import headerLayoutWrapper from "../../hoc/headerLayoutWrapper";
import {
  addLocation,
  getLocations,
  deleteLocation,
  updateLocation,
} from "../../services/services";
import { MapPin, X } from "lucide-react";
import { confirmDelete } from "../../components/confirmDelete";

const Location = () => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(15);
  const [showAddModal, setShowAddModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [nameError, setNameError] = useState(false);
  const nameInputRef = useRef(null);

  const [newLocation, setNewLocation] = useState({
    name: "",
  });

  const fetchLocations = async () => {
    try {
      setLoading(true);

      const res = await getLocations({});

      if (res.data.success) {
        setLocations(res.data.data);
      }
    } catch (err) {
      toast.error("Failed to load locations");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLocations();
  }, []);

  const handleAddLocation = async () => {
    if (!newLocation.name.trim()) {
      setNameError(true);
      toast.error("Location name is required");

      setTimeout(() => {
        nameInputRef.current?.focus();
      }, 0);

      return;
    }

    const payload = {
      name: newLocation.name,
      status: newLocation.status,
    };

    try {
      if (editingId) {
        const res = await updateLocation(editingId, payload);

        if (res.data.status) {
          toast.success(res.data.message);
          setEditingId(null);
        }
      } else {
        const res = await addLocation(payload);

        if (res.data.status) {
          toast.success(`${payload.name} added!`);
        }
      }

      setNewLocation({ name: "", status: "active" });
      setShowAddModal(false);
      fetchLocations();
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to save location");
    }
  };

  // const handleUpdate = (cat) => {
  //   setEditingId(cat._id);
  //   setNewLocation({ name: cat.name, status: cat.status });
  //   setShowAddModal(true);
  // };

  const handleDelete = async (id, name) => {
    const isConfirm = await confirmDelete(` ${name}`);
    if (!isConfirm) return;
    try {
      const res = await deleteLocation(id);
      if (res.data.success) {
        toast.success(res.data.message);
        fetchLocations();
      }
    } catch (error) {
      toast.error("Cannot delete - used in Product");
    }
  };
  const closeModal = () => {
    setShowAddModal(false);
    setEditingId(null);
    setNewLocation({ name: "", status: "active" });
    setNameError(false);
  };

  if (loading && locations.length === 0) return <Loading />;

  return (
    <>
      <div id="main">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="custom-title mb-0">Product Location</h4>
          <div>
            <button
              className="btn btn-primary"
              onClick={() => setShowAddModal(true)}
            >
              Add Location
              {/* <i className="bi bi-plus"></i>
              <span className="d-none d-md-inline ms-1"> Add Category</span> */}
            </button>
          </div>
        </div>

        <div className="card product-list-card shadow-sm">
          <div className="card-body p-0">
            {locations.length === 0 ? (
              <div className="text-center p-5">
                 <MapPin size={60} className="text-muted mb-3" /> 
                <p className="py-4 text-gray-500">No location yet.</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table align-middle   mb-0">
                  <thead
                    className="table-light small text-muted"
                    style={{ color: "#0b2b6d" }}
                  >
                    <tr>
                      <th>S.No</th>
                      <th>Location Name</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {locations.map((loc, i) => (
                      <tr key={loc._id}>
                        <td>{(page - 1) * limit + i + 1}</td>
                        <td className="fw-semibold">{loc.name}</td>

                        <td className="text-center">
                          <div>
                            {/* <button
                              className="btn btn-light btn-sm shadow-sm text-primary border"
                              onClick={() => handleUpdate(loc)}
                            >
                              <i class="bi bi-pencil"></i>
                            </button> */}
                            <button
                              className="btn btn-light btn-sm shadow-sm text-danger border"
                              onClick={() => handleDelete(loc._id, loc.name)}
                              title="Delete"
                            >
                              <i className="bi bi-trash"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>

      {showAddModal && (
        <div
          className="modal d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editingId ? "Edit Location" : "Add Location"}
                </h5>
                <X onClick={closeModal} style={{ cursor: "pointer" }} />
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">
                    Location Name
                    <span className="text-danger ms-1">*</span>
                  </label>
                  <input
                    ref={nameInputRef}
                    type="text"
                    className={`form-control ${nameError ? "is-invalid" : ""}`}
                    value={newLocation.name}
                    onChange={(e) => {
                      setNewLocation({
                        ...newLocation,
                        name: e.target.value,
                      });
                      if (nameError) setNameError(false);
                    }}
                    placeholder="e.g. Freezer, Godown, Kitchen, Warehouse"
                  />
                  {nameError && (
                    <div className="invalid-feedback">
                      Location name is required
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleAddLocation}
                >
                  {editingId ? "Update Location" : "Add Location"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default headerLayoutWrapper(Location);
